// extracted by mini-css-extract-plugin
export var errorIcon = "_jc-1";
export var nameLogo = "_jc-0";